import { render, staticRenderFns } from "./BSpinner.vue?vue&type=template&id=1b02a68f&scoped=true&"
import script from "./BSpinner.vue?vue&type=script&lang=js&"
export * from "./BSpinner.vue?vue&type=script&lang=js&"
import style0 from "./BSpinner.vue?vue&type=style&index=0&id=1b02a68f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02a68f",
  null
  
)

export default component.exports